import { Link } from "react-router-dom";
import LandingNav from "@/pages/home/components/LandingNav";

export default function CookiesPage() {
  return (
    <div className="min-h-screen bg-[#0A0B0F] text-white font-sans">
      <LandingNav />

      <section className="pt-28 pb-20 px-6">
        <div className="max-w-3xl mx-auto">
          <p className="text-[#C8A96E] text-xs font-semibold uppercase tracking-widest mb-3">Legal</p>
          <h1 className="text-4xl md:text-5xl font-black mb-4">Cookie Policy</h1>
          <p className="text-white/40 text-sm mb-12">Last updated: May 20, 2026</p>

          <div className="space-y-10 text-white/70 text-sm leading-relaxed">
            <div>
              <h2 className="text-white font-bold text-base mb-3">1. What Are Cookies</h2>
              <p>
                Cookies are small text files placed on your device when you visit a website. They help websites remember your preferences, keep you signed in, and understand how you interact with the platform. Pixory AI uses cookies and similar technologies to provide a secure, reliable, and personalized experience across our photography business management platform.
              </p>
            </div>

            <div>
              <h2 className="text-white font-bold text-base mb-3">2. Essential Cookies</h2>
              <p className="mb-3">
                These cookies are necessary for the core functionality of Pixory AI and cannot be disabled. They enable secure authentication, session management, and protect against security threats.
              </p>
              <div className="bg-[#141418] rounded-xl border border-white/5 overflow-hidden">
                <table className="w-full text-xs">
                  <thead>
                    <tr className="border-b border-white/5">
                      <th className="text-left py-3 px-4 text-white/50 font-medium">Cookie</th>
                      <th className="text-left py-3 px-4 text-white/50 font-medium">Purpose</th>
                      <th className="text-left py-3 px-4 text-white/50 font-medium">Duration</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr className="border-b border-white/5">
                      <td className="py-2.5 px-4 font-mono text-[#C8A96E]">pixory_session</td>
                      <td className="py-2.5 px-4">Authentication session token</td>
                      <td className="py-2.5 px-4">24 hours</td>
                    </tr>
                    <tr className="border-b border-white/5">
                      <td className="py-2.5 px-4 font-mono text-[#C8A96E]">pixory_csrf</td>
                      <td className="py-2.5 px-4">Cross-site request forgery protection</td>
                      <td className="py-2.5 px-4">Session</td>
                    </tr>
                    <tr>
                      <td className="py-2.5 px-4 font-mono text-[#C8A96E]">pixory_tenant</td>
                      <td className="py-2.5 px-4">Stores current studio context</td>
                      <td className="py-2.5 px-4">Session</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <div>
              <h2 className="text-white font-bold text-base mb-3">3. Functional Cookies</h2>
              <p className="mb-3">
                These cookies enhance your experience by remembering your preferences. While not strictly essential, disabling them may reduce platform usability.
              </p>
              <div className="bg-[#141418] rounded-xl border border-white/5 overflow-hidden">
                <table className="w-full text-xs">
                  <thead>
                    <tr className="border-b border-white/5">
                      <th className="text-left py-3 px-4 text-white/50 font-medium">Cookie</th>
                      <th className="text-left py-3 px-4 text-white/50 font-medium">Purpose</th>
                      <th className="text-left py-3 px-4 text-white/50 font-medium">Duration</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr className="border-b border-white/5">
                      <td className="py-2.5 px-4 font-mono text-[#C8A96E]">pixory_theme</td>
                      <td className="py-2.5 px-4">UI theme preference (light/dark)</td>
                      <td className="py-2.5 px-4">1 year</td>
                    </tr>
                    <tr className="border-b border-white/5">
                      <td className="py-2.5 px-4 font-mono text-[#C8A96E]">pixory_lang</td>
                      <td className="py-2.5 px-4">Language preference</td>
                      <td className="py-2.5 px-4">1 year</td>
                    </tr>
                    <tr>
                      <td className="py-2.5 px-4 font-mono text-[#C8A96E]">pixory_sidebar</td>
                      <td className="py-2.5 px-4">Sidebar collapsed/expanded state</td>
                      <td className="py-2.5 px-4">Session</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <div>
              <h2 className="text-white font-bold text-base mb-3">4. Analytics Cookies</h2>
              <p className="mb-3">
                We use minimal, privacy-focused analytics to understand how photographers use our platform and identify areas for improvement. No personally identifiable information is collected through analytics cookies.
              </p>
              <div className="bg-[#141418] rounded-xl border border-white/5 overflow-hidden">
                <table className="w-full text-xs">
                  <thead>
                    <tr className="border-b border-white/5">
                      <th className="text-left py-3 px-4 text-white/50 font-medium">Cookie</th>
                      <th className="text-left py-3 px-4 text-white/50 font-medium">Purpose</th>
                      <th className="text-left py-3 px-4 text-white/50 font-medium">Duration</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr className="border-b border-white/5">
                      <td className="py-2.5 px-4 font-mono text-[#C8A96E]">pixory_ga</td>
                      <td className="py-2.5 px-4">Anonymous page view tracking</td>
                      <td className="py-2.5 px-4">2 years</td>
                    </tr>
                    <tr>
                      <td className="py-2.5 px-4 font-mono text-[#C8A96E]">pixory_fp</td>
                      <td className="py-2.5 px-4">Anonymous feature usage patterns</td>
                      <td className="py-2.5 px-4">30 days</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <div>
              <h2 className="text-white font-bold text-base mb-3">5. Third-Party Cookies</h2>
              <p className="mb-3">
                Some features of Pixory AI rely on trusted third-party services that may set their own cookies. These include our payment processor for handling transactions and our cloud infrastructure provider for content delivery.
              </p>
              <p>
                We carefully select partners who comply with GDPR, CCPA, and other applicable privacy regulations. Third-party cookies are subject to the respective provider&apos;s privacy policies. No advertising or marketing cookies from third parties are used on our platform.
              </p>
            </div>

            <div>
              <h2 className="text-white font-bold text-base mb-3">6. Managing Cookies</h2>
              <p className="mb-3">
                Most web browsers allow you to control cookies through their settings. You can block all cookies, delete existing cookies, or set your browser to alert you when cookies are being placed. Note that blocking essential cookies will prevent you from signing into Pixory AI.
              </p>
              <p className="mb-3">
                For instructions on managing cookies in your browser, refer to your browser&apos;s help documentation:
              </p>
              <ul className="list-disc pl-5 space-y-1.5 text-white/50">
                <li><span className="text-white/70">Google Chrome:</span> Settings → Privacy and Security → Cookies</li>
                <li><span className="text-white/70">Mozilla Firefox:</span> Options → Privacy &amp; Security → Cookies</li>
                <li><span className="text-white/70">Apple Safari:</span> Preferences → Privacy → Cookies</li>
                <li><span className="text-white/70">Microsoft Edge:</span> Settings → Cookies and Site Permissions</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      <footer className="border-t border-white/5 py-8 px-6">
        <div className="max-w-3xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-4">
          <Link to="/" className="text-white/30 hover:text-white/60 text-xs transition-colors">← Back to Pixory AI</Link>
          <span className="text-white/20 text-xs">© 2025 Pixory AI. All rights reserved.</span>
        </div>
      </footer>
    </div>
  );
}